import SignatureInput from './SignatureInput'

export default SignatureInput
